import { CommunicationConfigurationEmailSenderSummaryModel } from './communicationConfigurationEmailSenderSummary.model';
import {IWithSummaryModel} from "src/app/modules/common/permission/api/entity/iWithSummary.model";

export class CommunicationConfigurationEmailSenderModel implements IWithSummaryModel<CommunicationConfigurationEmailSenderSummaryModel> {
    summary: CommunicationConfigurationEmailSenderSummaryModel;
    fromEmail: string;
    fromName: string;
    replyEmail: string;
    signature: string;
}